import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-discreteRate",
  "use": "deviceData-discreteRate-usage",
  "viewBox": "0 0 16 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 8\" id=\"deviceData-discreteRate\"><style>#deviceData-discreteRate .st0{fill-rule:evenodd;clip-rule:evenodd}</style><g id=\"deviceData-discreteRate_web\"><g id=\"deviceData-discreteRate_切图\" transform=\"translate(-32 -97)\"><path id=\"deviceData-discreteRate_形状结合\" class=\"st0\" d=\"M36.5 102.6c.4 0 .7.3.7.7s-.3.7-.7.7h-1.8c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h1.8zm4.4 0c.4 0 .7.3.7.7s-.3.7-.7.7h-1.8c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h1.8zm4.3 0c.4 0 .7.3.7.7s-.3.7-.7.7h-1.8c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h1.8zm0-3.6c.4 0 .7.3.7.7s-.3.7-.7.7H34.7c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h10.5z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-discreteRate.svg
// module id = a8aX
// module chunks = 6